import {useGetOdontoSpecialtiesQuery} from 'presentation/modules/booking/odonto/ui/pages/OdontoBooking/steps/OdontoSpecialtySelection/queries/useGetOdontoSpecialtiesQuery';
import {useQueryParams} from 'presentation/pages';

export function useOdontoFilterByLetter() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const {
		data: specialtiesList,
		isError: specialtiesListError,
		isFetching: isFetchingSpecialtiesList,
	} = useGetOdontoSpecialtiesQuery();

	const NOT_FOUND = !specialtiesList || specialtiesList.length === 0;
	const HIDDEN_FILTER_BY_LETTER = specialtiesListError || isFetchingSpecialtiesList || NOT_FOUND;

	const FILTERED_LIST_BY_CATEGORY = specialtiesList?.map(specialty => ({
		...specialty,
		list: specialty.list.filter(item =>
			item.formattedText.toLowerCase().includes(query.trim().toLowerCase()),
		),
	}));

	return {
		FILTERED_LIST_BY_CATEGORY,
		HIDDEN_FILTER_BY_LETTER,
	};
}
